import { useState } from 'react'

export const useForm = (initialState = {}) => {

    const [formState, setFormState] = useState(initialState)

    const onInputChange = ({ target }) => {
        const { name, value } = target
        setFormState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    // Para campos tipo dinero: muestra con comas y guarda limpio (clean_<name>) para el backend
    const onInputChangeForNumber = ({ target }) => {
        const { name, value } = target

        const cleanValue = value.replace(/,/g, '')
        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue)
        if (!validNumber) return

        if (cleanValue === '' || cleanValue === '.') {
            setFormState(prev => ({
                ...prev,
                [name]: value,
                [`clean_${name}`]: null,
            }))
            return
        }

        let [integerPart, decimalPart] = cleanValue.split('.')
        if (decimalPart !== undefined) decimalPart = decimalPart.slice(0, 2)

        const formattedInteger = new Intl.NumberFormat('en-US', {
            useGrouping: true,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(parseFloat(integerPart || 0))
        const formattedValue = decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger

        setFormState(prev => ({
            ...prev,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue),
        }))
    }

    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState(prev => ({ ...prev, acceptedFiles: arrayAccepted }))
    }

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState(prev => ({ ...prev, fileRejections: arrayRejections }))
    }

    const onResetForm = () => {
        setFormState(initialState)
    }

    const onSelectSearchChange = ({ target }) => {
        const { name, value } = target
        setFormState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    return {
        formState,
        setFormState,
        onInputChange,
        onInputChangeForNumber,
        onSelectSearchChange,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange,
        onResetForm
    }
}
